<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
};
</script>

<style lang="scss">
@import "../node_modules/font-awesome/css/font-awesome.min.css";
@import "./assets/style/common";
</style>



// WEBPACK FOOTER //
// App.vue?1701afa4